module.exports = __webpack_public_path__ + "img/ws-4.f56a1cc7.jpg";